import styled from 'styled-components';
import { Layout } from '../../styles/layout';
import { Image } from '../../styles/image';
import { VisorEmblemLogo } from '../../components/visor-emblem-logo';
import {
  borderColor,
  borderRadius,
  cardBackground,
  cardShadow,
  fontFamily,
  primaryColor,
  textColorDark,
} from '../../utils/variables';

export const LoginScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  background: var(--login-background);
  padding: 1.5rem;
`;

export const LoginCard = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background: ${cardBackground};
  border: 1px solid ${borderColor};
  border-radius: ${borderRadius};
  box-shadow: ${cardShadow};
`;

export const LoginLogo = styled(VisorEmblemLogo)`
  height: 40px;
  width: auto;
  color: ${primaryColor};
`;

export const LoginTitle = styled.h1`
  margin: 1rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
  font-family: ${fontFamily};
  color: ${textColorDark};
  text-align: center;
`;

export const PasswordLayout = styled(Layout)`
    position: relative;
    width: 100%;

    img {
        position: absolute;
        right: 12px;
        top: calc(50% - 8px);
        cursor: pointer;
        opacity: .7;
        transition: 250ms;

        :hover {
            opacity: 1;
        }
    }
`;
